import type { CallSummary } from "../../@types/sharedSchema";

export function getTimeBySeconds(seconds: number) {
  if (!Number.isFinite(seconds) || seconds < 0) return "00:00:00";
  return new Date(seconds * 1000).toISOString().slice(11, 19);
}

export function getAudioUrlFromCallSummary(call: CallSummary): string {
  const { createdTime, recordingLinkReplicatedToFirebaseUrl, recordingLinkDirect } = call;

  let audioUrl = recordingLinkDirect;

  const shouldUseFirebaseUrl =
    recordingLinkReplicatedToFirebaseUrl && createdTime > new Date("2024-09-30");

  if (shouldUseFirebaseUrl) audioUrl = recordingLinkReplicatedToFirebaseUrl;

  return audioUrl;
}
